export const getTokenTypeName = (tokenTypeId, tokenTypes, lang = 'nl') => {
    const tokenType = tokenTypes.find(t => t.id === tokenTypeId);
    return (lang === 'en' ? tokenType.naamEN : tokenType.naam) || "";
};
export default getTokenTypeName;